import React from "react";
import { usePageMeta } from "@/components/site/usePageMeta";
import { Hero } from "@/components/site/Hero";
import { CityMarquee } from "@/components/site/CityMarquee";
import { IdxSection } from "@/components/site/IdxSection";
import { FeaturedCities } from "@/components/site/FeaturedCities";
import { PathSection } from "@/components/site/PathSection";
import { BuyerSection } from "@/components/site/BuyerSection";
import { RecruitingSection } from "@/components/site/RecruitingSection";
import { SellerSection } from "@/components/site/SellerSection";
import { FinancingSection } from "@/components/site/FinancingSection";
import { MortgageCalculator } from "@/components/site/MortgageCalculator";
import { AboutSection } from "@/components/site/AboutSection";
import { WhySection } from "@/components/site/WhySection";
import { Testimonials } from "@/components/site/Testimonials";
import { GallerySection } from "@/components/site/GallerySection";
import { ServiceAreas } from "@/components/site/ServiceAreas";
import { ContactSection } from "@/components/site/ContactSection";
import { FaqSection } from "@/components/site/FaqSection";
import { TrustBadges } from "@/components/site/TrustBadges";

export default function Home() {
  usePageMeta(
    "Wallstreet Realty | Southern California Real Estate & Mortgage Brokerage",
    "Search Southern California homes, connect with a local buyer agent, get real estate and mortgage guidance, sell with strategy, and join a growth-focused brokerage. Serving LA & Orange County."
  );
  return (
    <>
      <Hero />
      <CityMarquee />
      <IdxSection />
      <FeaturedCities />
      <PathSection />
      <BuyerSection />
      <RecruitingSection />
      <SellerSection />
      <FinancingSection />
      <MortgageCalculator />
      <AboutSection />
      <WhySection />
      <Testimonials />
      <GallerySection />
      <ServiceAreas />
      <ContactSection />
      <FaqSection />
      <TrustBadges />
    </>
  );
}
